module.exports = __webpack_public_path__ + "static/media/example1.cca41dfc.gif";